import { Button, Modal } from "../../components";
import { useState } from "react";

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  isLOC?: boolean;
  comment?: string;
  onChangeComment?: (val: string) => void;
  isLoading?: boolean;
};

const LoanOfferRejectModel: React.FC<Props> = ({
  isOpen,
  onCancel,
  onConfirm,
  isLOC = false,
  comment = "",
  onChangeComment,
  isLoading = false,
}) => {
  const [acknowledged, setAcknowledged] = useState(false);

  if (isLOC) {
    return (
      <Modal
        isOpen={isOpen}
        onClose={onCancel}
        title="Decline your application?"
      >
        <div className="cx-flex cx-flex-col cx-gap-6">
          <div className="cx-text-center cx-text-text-secondary cx-text-base">
            Are you sure you want to cancel your loan application? If you need
            our support feel free to contact us.
          </div>
          <div className="cx-flex cx-flex-col cx-gap-2">
            <textarea
              className="cx-w-full cx-min-h-[100px] cx-rounded-md cx-border cx-border-divider-subtle cx-px-3 cx-py-2 cx-text-sm focus:cx-outline-none focus:cx-border-brand-primary-regular"
              placeholder="Add a comment..."
              value={comment}
              onChange={(e) => onChangeComment?.(e.target.value)}
            />
            <div className="cx-flex cx-items-center cx-gap-2 cx-w-full cx-bg-[#F8F8F8] cx-rounded-md cx-border cx-border-divider-subtle cx-px-4 cx-py-3 cx-mt-2">
              <input
                id="loc-ack-checkbox"
                type="checkbox"
                className="cx-h-4 cx-w-4 cx-rounded cx-border cx-border-divider-subtle focus:cx-outline-none focus:cx-ring-1 focus:cx-ring-brand-primary-regular"
                checked={acknowledged}
                onChange={(e) => setAcknowledged(e.target.checked)}
              />
              <label
                htmlFor="loc-ack-checkbox"
                className="cx-text-sm cx-text-text-secondary"
              >
                I understand this cannot be undone
              </label>
            </div>
          </div>
          <div className="cx-flex cx-gap-4 cx-w-full">
            <Button label="Go Back" outlined fullWidth onClick={onCancel} />
            <Button
              label="Decline"
              disabled={!acknowledged}
              danger
              fullWidth
              onClick={onConfirm}
              {...(isLoading && { loader: "left" })}
            />
          </div>
        </div>
      </Modal>
    );
  }

  return (
    <Modal isOpen={isOpen} onClose={onCancel} title="Decline loan offer">
      <div className="cx-flex cx-flex-col cx-items-center cx-gap-6">
        <div className="cx-text-center cx-text-text-secondary cx-text-base">
          Are you sure you would like to decline this offer? When offer is
          declined it will be permanently removed from your account.
        </div>
        <div className="cx-flex cx-gap-4 cx-w-full">
          <Button
            label="Decline"
            danger
            fullWidth
            onClick={onConfirm}
            {...(isLoading && { loader: "left" })}
          />
          <Button label="Cancel" outlined fullWidth onClick={onCancel} />
        </div>
      </div>
    </Modal>
  );
};

export default LoanOfferRejectModel;
